// Client-side mirror of the backend's reference-number generation. Format:
// {2 initials}{MMDDYYYY}_{4 hex}, matching ^[A-Z]{2}\d{8}_[0-9A-F]{4}$.

const INITIALS_LENGTH = 2;
const FALLBACK_INITIAL = 'X';
const ASCII_LETTER = /[A-Z]/;
const HEX_SUFFIX_BYTES = 2; // -> 4 hex characters

/** Up to two uppercase initials; falls back to 'X' for missing/non-ASCII names. */
function deriveInitials(fullname: string): string {
    const letters = fullname
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .map((token) => token.charAt(0).toUpperCase())
        .filter((ch) => ASCII_LETTER.test(ch));

    while (letters.length < INITIALS_LENGTH) {
        letters.push(FALLBACK_INITIAL);
    }
    return letters.slice(0, INITIALS_LENGTH).join('');
}

function formatDateStamp(date: Date): string {
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = String(date.getFullYear());
    return `${mm}${dd}${yyyy}`;
}

function randomHexSuffix(): string {
    const bytes = new Uint8Array(HEX_SUFFIX_BYTES);
    crypto.getRandomValues(bytes);
    return Array.from(bytes, (b) => b.toString(16).padStart(2, '0'))
        .join('')
        .toUpperCase();
}

export function generateReferenceNo(fullname: string): string {
    return `${deriveInitials(fullname)}${formatDateStamp(new Date())}_${randomHexSuffix()}`;
}
